import { Helpers } from '../../helpers';
import { IEquationType } from '../../interfaces/iequation-type';
import { Equation } from '../equation';

export class EquationTypeBase {
  EquationTypeId: number;
  Description: string;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Equations_EquationType?: Array<Equation> | null;

  constructor(item?: IEquationType) {
    if (item) {

      this.EquationTypeId = item.EquationTypeId;
      this.Description = item.Description;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Equations_EquationType = Helpers.createClassArray(Equation, item.Equations_EquationType);
    }
  }
}